import { render, staticRenderFns } from "./IconSushifox.vue?vue&type=template&id=08b273c1&"
import script from "./IconSushifox.vue?vue&type=script&lang=js&"
export * from "./IconSushifox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports